<div class="social-media-input mct-flex mct-col mct-gap-10"  >
  <div>
    <span>{{ 'profiles.edit.social-media.add-social-media' | translate | titlecase }}</span>
    <select class="form-control" (change)="onSelectSocialMediaType($event)">
      <option>{{ 'common.select' | translate | titlecase }}</option>
      <option *ngFor="let socialMediaType of sortedSocialMediaTypes()" [value]="socialMediaType.SocialMediaTypeID">{{
        socialMediaType.Name
      }}</option>
    </select>
  </div>
  <div class="mct-flex mct-col mct-gap-10"  >
    <div class="mct-flex mct-col mct-gap-10" *ngFor="let socialMedia of sortedSocialMedias()"  >
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"   >
        <img [src]="mapToIconAsset(socialMedia.SocialMediaType.Name)" />
        <a [href]="socialMedia.SocialMediaType.SocialNetworkingHomePage">{{ socialMedia.SocialMediaType.Name }}</a>
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5"   >
        <input class="mct-flex-1-1-0"
          #socialMediaInputs
          
          id="sm-{{ socialMedia.SocialMediaType.SocialMediaTypeID }}"
          type="text"
          [(ngModel)]="socialMedia.URL"
        />
        <button
          class="btn btn-danger"
          type="button"
          (click)="deleteSocialMedia(socialMedia.SocialMediaTypeID)"
          title="{{ 'common.delete' | translate | titlecase }}"
        >
          {{ 'common.delete' | translate | titlecase }}
        </button>
      </div>
    </div>
  </div>
</div>
